export function isObject(value: any): boolean {
  return value !== null && typeof value === "object";
}

export function isString(value: any): boolean {
  return typeof value === "string";
}

export function joinUrl(baseUrl: string, url: string): string {
  if (/^(?:[a-z]+:)?\/\//i.test(url)) {
    return url;
  }
  let joined = baseUrl ? [baseUrl, url].join("/") : url;
  let normalize = function (str: string) {
    return str
      .replace(/[\/]+/g, "/")
      .replace(/\/\?/g, "?")
      .replace(/\/\#/g, "#")
      .replace(/\:\//g, "://");
  };
  return normalize(joined);
}
